import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PdfService } from 'src/app/core/pdf.service';
import { UserService } from 'src/app/core/user.service';
import { User } from 'src/app/models/user.model';

@Component({
  selector: 'app-text-step',
  templateUrl: './text-step.component.html',
  styleUrls: ['./text-step.component.scss'],
  standalone: false
})
export class TextStepComponent {

  @Input() form!: FormGroup;
  @Input() selectedFiles: any = [];
  @Output() selectedFilesChange = new EventEmitter<File>();

  user?: User;

  showRestrictionInfo: boolean = false;
  showPromptInput: boolean = false;

  constructor(
    private pdfService: PdfService,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.userService.getUser().subscribe((user) => this.user = user);
  }

  promptCheckboxValueChanged(value: boolean) {
    this.showPromptInput = value;
    this.form.get('prompt')?.setValidators(value ? [Validators.required] : []);
    this.form.get('prompt')?.updateValueAndValidity();
  }
  
  getControl(control: string) {
    return this.form!.get(control) as FormControl;
  }

  fileSelectionChanged(files: any): void {
    this.selectedFiles = files;
    this.checkAndApplyRestriction(files);
    this.selectedFilesChange.emit(files);
  }

  checkAndApplyRestriction(files: any) {
    if (!files || files.length === 0) {
      this.showRestrictionInfo = false;
      return;
    }

    if (this.user?.isPremiumUser === false) {
      this.pdfService.getPdfPageCount(files[0]).then((num) => {
        if (num > 20) {
          this.showRestrictionInfo = true;
        }
      });
    } else {
      this.showRestrictionInfo = false;
    }
  }
}
